import React, { useState, useEffect } from "react";
import {
  Card,
  Button,
  Container,
  Row,
  Col,
  InputGroup,
  FormControl,
  Table,
  DropdownButton,
  Dropdown,
  Accordion,
  Form,
} from "react-bootstrap";
import NoData from "../../components/NoData";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL, HEADERS } from "../../utils/constant";
import ExportModal from "../../components/Modals/ExportsModel/main";
import ImportModal from "../../components/Modals/ImportModel";
import Loader from "../../components/Loader";
import {
  MdArrowBackIos,
  MdArrowForwardIos,
  MdCancel,
  MdCheckCircle,
} from "react-icons/md";
import { BsThreeDotsVertical } from "react-icons/bs";
import {
  FaEdit,
  FaFileExport,
  FaFileImport,
  FaPlus,
  FaTrashAlt,
  FaUserCircle,
} from "react-icons/fa";
import ReactPaginate from "react-paginate";
import { useCommonContext } from "../../utils/context";
import AgentModal from "../../components/Modals/AgentModel";
import CommonButton from "../../components/CommonButton";
import Pagination from "../../components/Pagination";
import ViewModal from "../../components/Modals/HisstoryModals/UserViewModel";

const Sales = () => {
  const [showSaleModal, setShowSaleModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [sales, setSales] = useState([]);
  const [loading, setLoading] = useState(false);
  const { toggled } = useCommonContext();

  const [editSaleData, setEditSaleData] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [selectedSales, setSelectedSales] = useState([]);
  const role = localStorage.getItem("role");
  const [exportLoading, setExportLoading] = useState(false);
  const [statusFilter, setStatusFilter] = useState("true");
  const [itemOffset, setItemOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = sales;
  const pageCount = Math.ceil(sales.length / itemsPerPage);
  const [showViewModal, setShowViewModal] = useState(false);

  useEffect(() => {
    fetchSales(currentPage);
  }, [currentPage, itemsPerPage, searchText, statusFilter]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchText]);

  const fetchSales = async (page = 1) => {
    setLoading(true);
    try {
      let url = `${BASE_URL}/users/tms_users/`;
      if (statusFilter === false) {
        url = `${BASE_URL}/users/tms_users/deactivate-users/`;
      }

      const response = await axios.get(url, {
        headers: HEADERS,
        params: {
          role: "sales",
          page: page,
          page_size: itemsPerPage,
          search: searchText || undefined,
          ...(statusFilter !== false && {
            is_active: statusFilter !== null ? statusFilter : undefined,
          }),
        },
      });

      if (response.data?.results) {
        setSales(response.data.results);
        setTotalPages(response.data.total_pages);
        setCurrentPage(page);
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setCurrentPage(1);
        fetchSales(1);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleEditSale = (sale) => {
    setEditSaleData(sale);
    setShowSaleModal(true);
  };

  const handleDeleteSale = async (saleId) => {
    try {
      const response = await axios.delete(
        `${BASE_URL}/users/tms_users/${saleId}/`,
        {
          headers: {
            ...HEADERS,
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (response) {
        toast.success("User deleted successfully!");
        fetchSales(currentPage);
      } else {
        toast.error("Failed to delete User. Please try again.");
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorData = error.response.data.error;

        if (typeof errorData === "object" && !Array.isArray(errorData)) {
          Object.entries(errorData).forEach(([field, messages]) => {
            if (Array.isArray(messages)) {
              messages.forEach((message) => {
                toast.error(`${message}`);
              });
            } else {
              toast.error(`${messages}`);
            }
          });
        } else {
          toast.error("Unexpected error format. Please try again.");
        }
      } else {
        toast.error("Error Please Try again.");
      }
    }
  };

  const handleToggleActive = async (saleId, currentStatus) => {
    try {
      const response = await axios.put(
        `${BASE_URL}/users/tms_users/${saleId}/`,
        { is_active: !currentStatus },
        {
          headers: {
            ...HEADERS,
            "Content-Type": "application/json",
          },
        },
      );
      if (response.status === 200) {
        toast.success(
          `Sales ${currentStatus ? "deactivated" : "activated"} successfully!`,
        );
        fetchSales(currentPage);
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorData = error.response.data.error;

        if (typeof errorData === "object" && !Array.isArray(errorData)) {
          Object.entries(errorData).forEach(([field, messages]) => {
            if (Array.isArray(messages)) {
              messages.forEach((message) => {
                toast.error(`${message}`);
              });
            } else {
              toast.error(`${messages}`);
            }
          });
        } else {
          toast.error("Unexpected error format. Please try again.");
        }
      } else {
        toast.error("Error Please Try again.");
      }
    }
  };

  const handleCloseModals = () => {
    setShowSaleModal(false);
    setShowImportModal(false);
    setEditSaleData(null);
  };

  const handleViewUser = (sale) => {
    setSelectedSales(sale);
    setShowViewModal(true);
  };

  const handlePageClick = (selectedPage) => {
    const newPage = selectedPage.selected + 1;
    setCurrentPage(newPage);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const formatTime = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(timestamp);
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  const handleAddUser = () => {
    setEditSaleData(null);
    setShowSaleModal(true);
  };

  return (
    <div className="container-fluid ">
      <div className="mt-3 d-flex container-header flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3">
        <h4 className="mb-2 mb-md-0">Sales</h4>

        <div className="d-none d-md-flex align-items-center gap-2">
          <Form.Control
            type="text"
            placeholder="Search Here..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            className="uniform-input search-text"
          />

          <Form.Select
            value={
              statusFilter === true
                ? "is_active"
                : statusFilter === false
                  ? "!is_active"
                  : ""
            }
            onChange={(e) => {
              const value = e.target.value;
              if (value === "is_active") {
                setStatusFilter(true);
              } else if (value === "!is_active") {
                setStatusFilter(false);
              } else {
                setStatusFilter(null);
              }
            }}
            className="uniform-input"
          >
            <option value="is_active">Active</option>
            <option value="!is_active">Inactive</option>
          </Form.Select>

          <CommonButton className="uniform-button" onClick={handleAddUser}>
            <FaPlus className="me-1" /> Add
          </CommonButton>

          <CommonButton
            className="uniform-button"
            onClick={() => setShowImportModal(true)}
          >
            <FaFileImport className="me-1" /> Import
          </CommonButton>

          <CommonButton
            className="uniform-button"
            onClick={() => setShowExportModal(true)}
            disabled={currentItems.length === 0}
          >
            <FaFileExport className="me-1" />{" "}
            {exportLoading ? "Exporting..." : "Export"}
          </CommonButton>
        </div>
        <div className="d-md-none w-100">
          <Accordion flush>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Filters & Actions</Accordion.Header>
              <Accordion.Body className="pt-3">
                <Form.Control
                  type="text"
                  placeholder="Search Here..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  className="uniform-input search-text mb-3"
                />

                <Form.Select
                  value={
                    statusFilter === true
                      ? "is_active"
                      : statusFilter === false
                        ? "!is_active"
                        : ""
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "is_active") {
                      setStatusFilter(true);
                    } else if (value === "!is_active") {
                      setStatusFilter(false);
                    } else {
                      setStatusFilter(null);
                    }
                  }}
                  className="uniform-input mb-3"
                >
                  <option value="is_active">Active</option>
                  <option value="!is_active">Inactive</option>
                </Form.Select>
                <div className="row g-2 mt-2">
                  <div className="col-12 col-sm-6 col-md-4">
                    <CommonButton
                      className="uniform-button w-100 d-flex justify-content-center align-items-center"
                      onClick={handleAddUser}
                    >
                      <FaPlus className="me-1" /> Add
                    </CommonButton>
                  </div>

                  <div className="col-12 col-sm-6 col-md-4">
                    <CommonButton
                      className="uniform-button w-100 d-flex justify-content-center align-items-center"
                      onClick={() => setShowImportModal(true)}
                    >
                      <FaFileImport className="me-1" /> Import
                    </CommonButton>
                  </div>

                  <div className="col-12 col-sm-6 col-md-4">
                    <CommonButton
                      className="uniform-button w-100 d-flex justify-content-center align-items-center"
                      onClick={() => setShowExportModal(true)}
                      disabled={currentItems.length === 0}
                    >
                      <FaFileExport className="me-1" />{" "}
                      {exportLoading ? "Exporting..." : "Export"}
                    </CommonButton>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>

      <div
        className={`table-responsive ${currentItems.length === 0 ? "" : "tabell"} `}
      >
        {loading ? (
          <Loader />
        ) : (
          <>
            {currentItems.length > 0 ? (
              <table className="table   tstart">
                <thead className="thead">
                  <tr style={{ whiteSpace: "nowrap" }}>
                    {/* <th style={{ width: "50px" }}>
                  <input
                    type="checkbox"
                    onChange={handleSelectAll}
                    checked={selectedsaleIds.length === currentItems.length}
                  />
                </th> */}
                    <th style={{ width: "350px" }}>Name</th>
                    <th style={{ width: "300px" }}>Email</th>
                    <th style={{ width: "200px" }}>Phone</th>
                    <th style={{ width: "200px" }}>Date of Joining</th>
                    <th style={{ width: "200px" }}>Casual Leaves</th>
                    <th style={{ width: "200px" }}>Sick Leaves</th>
                    <th style={{ width: "200px" }}>Punch-In Time</th>
                    <th style={{ width: "200px" }}>Punch-Out Time</th>
                    <th style={{ width: "150px" }}>Status</th>
                    <th style={{ width: "150px" }}>Latitude</th>
                    <th style={{ width: "150px" }}>Longitude</th>
                    <th style={{ width: "150px" }}>GPS Status</th>
                    <th style={{ width: "150px" }}></th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((sale, index) => (
                    <tr
                      key={sale.id}
                      onClick={() => handleViewUser(sale)}
                      className="tbody"
                      style={{
                        background: index % 2 === 0 ? "#f2f2f2" : "#fff",
                      }}
                    >
                      {/* <td>
                    <input
                      type="checkbox"
                      checked={selectedsaleIds.includes(sale.id)}
                      onChange={() => handleSelectsale(sale.id)}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </td> */}

                      <td>
                        <div className="d-flex align-items-center ">
                          <span className="badge bg-primary text-white me-2 emp-id-badge">
                            {sale.emp_id || "—"}
                          </span>
                          {sale.profile_image ? (
                            <img
                              src={sale.profile_image}
                              alt="Profile"
                              className="rounded-circle border me-2"
                              style={{ width: "30px", height: "30px" }}
                            />
                          ) : (
                            <FaUserCircle
                              size={30}
                              className="text-primary me-2"
                            />
                          )}
                          <div
                            title={sale.first_name || "—"}
                            className="tdsubject"
                          >
                            {sale.first_name} {sale.last_name}
                          </div>
                        </div>
                      </td>

                      <td>
                        <div title={sale.email || "—"} className="tdsubject">
                          {sale.email || "—"}
                        </div>
                      </td>

                      <td>
                        <div
                          title={sale.phone_number || "—"}
                          className="tdsubject"
                        >
                          {sale.phone_number || "—"}
                        </div>
                      </td>

                      <td>
                        <div
                          title={sale.date_joined || "—"}
                          className="tdsubject"
                        >
                          {sale.date_joined || "—"}
                        </div>
                      </td>

                      <td>
                        <div
                          title={sale.allocated_casual_leave || "—"}
                          className="tdsubject"
                        >
                          {sale.allocated_casual_leave || "—"}
                        </div>
                      </td>
                      <td>
                        <div
                          title={sale.allocated_sick_leave || "—"}
                          className="tdsubject"
                        >
                          {sale.allocated_sick_leave || "—"}
                        </div>
                      </td>
                      <td>
                        <div
                          title={
                            sale.today_attendance?.punch_in
                              ? formatTime(sale.today_attendance?.punch_in)
                              : "—"
                          }
                          className="tdsubject"
                        >
                          {sale.today_attendance?.punch_in
                            ? formatTime(sale.today_attendance?.punch_in)
                            : "—"}
                        </div>
                      </td>
                      <td>
                        <div
                          title={
                            sale.today_attendance?.punch_out
                              ? formatTime(sale.today_attendance?.punch_out)
                              : "—"
                          }
                          className="tdsubject"
                        >
                          {sale.today_attendance?.punch_out
                            ? formatTime(sale.today_attendance?.punch_out)
                            : "—"}
                        </div>
                      </td>

                      <td>
                        {sale.today_attendance?.status || "NA"}
                        <br />
                        <span
                          className={`badge ${
                            sale.is_active ? "bg-success" : "bg-danger"
                          }`}
                        >
                          {sale.is_active ? "Active" : "Inactive"}
                        </span>
                      </td>
                      {/* <td>
                            <div
                              title={
                                moment(sale.startDate).format(
                                  "YYYY-MM-DD HH:mm:ss"
                                ) || "—"
                              }
                              className="tdsubject"
                            >
                              {moment(sale.startDate).format(
                                "YYYY-MM-DD"
                              ) || "—"}
                              <br />
                              <span className="badge bg-primary text-white">
                                {moment(sale.startDate).format(
                                  "HH:mm:ss"
                                ) || "—"}
                              </span>
                            </div>
                          </td> */}
                      <td>
                        <div
                          title={sale.longitude ? `${sale.longitude}` : "—"}
                          className="tdsubject"
                        >
                          {sale.longitude ? `${sale.longitude}` : "—"}
                        </div>
                      </td>
                      <td>
                        <div
                          title={sale.latitude ? `${sale.latitude}` : "—"}
                          className="tdsubject"
                        >
                          {sale.latitude ? `${sale.latitude}` : "—"}
                        </div>
                      </td>
                      <td>{sale.gps_status ? "On" : "Off"}</td>

                      <td>
                        <div className="ms-auto">
                          <DropdownButton
                            id="dropdown-basic-button"
                            title={<BsThreeDotsVertical />}
                            variant="link"
                            onClick={(e) => e.stopPropagation()}
                            className="p-0 text-secondary custom-dropdown"
                          >
                            <Dropdown.Item
                              onClick={(e) => {
                                e.stopPropagation();
                                handleEditSale(sale);
                              }}
                            >
                              <FaEdit className="me-2" /> Edit
                            </Dropdown.Item>

                            {role === "admin" && (
                              <Dropdown.Item
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDeleteSale(sale.id);
                                }}
                              >
                                <FaTrashAlt className="me-1" /> Delete
                              </Dropdown.Item>
                            )}

                            <Dropdown.Item
                              as="button"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleToggleActive(sale.id, sale.is_active);
                              }}
                            >
                              {sale.is_active ? (
                                <>
                                  <MdCancel className="me-2" /> Deactivate
                                </>
                              ) : (
                                <>
                                  <MdCheckCircle className="me-2" /> Activate
                                </>
                              )}
                            </Dropdown.Item>
                          </DropdownButton>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <NoData message="No Data Found" height="400px" />
            )}
          </>
        )}
      </div>

      {currentItems.length > 0 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          itemsPerPage={itemsPerPage}
          handlePageClick={handlePageClick}
          handleItemsPerPageChange={handleItemsPerPageChange}
        />
      )}

      {showSaleModal && (
        <AgentModal
          show={showSaleModal}
          handleClose={handleCloseModals}
          agentData={editSaleData}
          roletype="sales"
          fetchAgents={() => fetchSales(currentPage)}
        />
      )}

      <ViewModal
        show={showViewModal}
        handleClose={() => setShowViewModal(false)}
        userId={selectedSales?.id}
        user={selectedSales}
      />

      <ExportModal
        show={showExportModal}
        handleClose={() => setShowExportModal(false)}
        title="sales"
      />

      {showImportModal && (
        <ImportModal
          show={showImportModal}
          handleClose={handleCloseModals}
          type="sales"
          onSuccess={() => fetchSales(currentPage)}
        />
      )}
    </div>
  );
};

export default Sales;
